import { render, staticRenderFns } from "./AddEdit.vue?vue&type=template&id=36cbabac&scoped=true"
import script from "./AddEdit.vue?vue&type=script&lang=js"
export * from "./AddEdit.vue?vue&type=script&lang=js"
import style0 from "./AddEdit.vue?vue&type=style&index=0&id=36cbabac&prod&lang=css"
import style1 from "./AddEdit.vue?vue&type=style&index=1&id=36cbabac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cbabac",
  null
  
)

export default component.exports